exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (min-width:1000px) and (max-width:1200px){.header .page{width:900px!important}.header .page .logo{width:90px!important}.header .page .head-tel{margin-left:15px!important}.header .page .head-tel img{width:130px!important}.header .page .header_wrap .el-tabs__active-bar{width:84px!important;border:1px solid red!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./src/assets/css/media/header/header.css
// module id = 185
// module chunks = 28